import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { SchoolTypeInterface } from './../+models/SchoolType.interface';

export const SCHOOL_TYPE_SERVICE_TOKEN = new InjectionToken('SchoolTypeService');

export interface SchoolTypeServiceInterface {
  getAll(): Observable<SchoolTypeInterface[]>;
  getSchoolTypes$(
    searchTerm?: string,
    filters?: { [key: string]: string | number[] | number },
    pagination?: { from?: any; amount?: any },
    columns?: string[],
    sorting?: { [key: string]: 'asc' | 'desc' }
  ): Observable<{ results: SchoolTypeInterface[]; count: number }>;
  deleteSchoolType$(id: number): Observable<boolean>;
  createSchoolType(schoolType: SchoolTypeInterface): Observable<SchoolTypeInterface>;
  updateSchoolType(schoolType: SchoolTypeInterface): Observable<SchoolTypeInterface>;
}
